import React from 'react';

function FilterBar({
  filters = [],
  view = 'table',
  onViewChange,
  className = '',
}) {
  return (
    <div className={`flex flex-wrap items-center justify-between gap-3 bg-[var(--axial-card)] ${className}`}>
      <div className="flex flex-wrap items-center gap-2">
        {filters.map(filter => (
          <label
            key={filter.key}
            className="inline-flex items-center gap-2 px-2.5 h-9 rounded-md border border-gray-700 bg-[var(--axial-card)] text-xs text-gray-300"
          >
            <span className="text-gray-500">{filter.label}</span>
            <select
              className="bg-[var(--axial-card)] text-gray-100 outline-none"
              value={filter.value}
              onChange={event => filter.onChange(event.target.value)}
            >
              {filter.options.map(option => (
                <option key={option.value} value={option.value} className="bg-[var(--axial-card)] text-gray-100">
                  {option.label}
                </option>
              ))}
            </select>
          </label>
        ))}
      </div>


    </div>
  );
}

export default FilterBar;
